export class WalletError extends Error {
    code;
    i18nKey;
    constructor(code, i18nKey, message) {
        super(message ?? i18nKey);
        this.name = 'WalletError';
        this.code = code;
        this.i18nKey = i18nKey;
    }
}
export class NetworkError extends WalletError {
    canRetry;
    constructor(code, i18nKey, canRetry, message) {
        super(code, i18nKey, message);
        this.name = 'NetworkError';
        this.canRetry = canRetry;
    }
}
export class TransactionError extends WalletError {
    details;
    constructor(code, i18nKey, details = {}, message) {
        super(code, i18nKey, message);
        this.name = 'TransactionError';
        this.details = details;
    }
}
export class CryptoError extends WalletError {
    constructor(code, i18nKey, message) {
        super(code, i18nKey, message);
        this.name = 'CryptoError';
    }
}
export class StorageError extends WalletError {
    constructor(code, i18nKey, message) {
        super(code, i18nKey, message);
        this.name = 'StorageError';
    }
}
const KNOWN_COSMOS_CODES = new Set([2, 5, 11, 13, 32]);
export function mapCosmosCode(code, rawLog) {
    const i18nKey = KNOWN_COSMOS_CODES.has(code)
        ? `errors.cosmos.code.${code}`
        : 'errors.cosmos.code.unknown';
    return new TransactionError('BROADCAST_REJECTED', i18nKey, {
        chainCode: code,
        rawLog,
    });
}
const SLOW_FETCH_THRESHOLD_MS = 2_500;
export function classifyFetchError(err, elapsedMs) {
    if (err instanceof Error && err.name === 'AbortError') {
        return new NetworkError('NETWORK_TIMEOUT', 'errors.network.timeout', true, err.message);
    }
    if (err instanceof TypeError && /fetch/i.test(err.message)) {
        return new NetworkError('NETWORK_OFFLINE', 'errors.network.offline', true, err.message);
    }
    if (elapsedMs >= SLOW_FETCH_THRESHOLD_MS) {
        return new NetworkError('NETWORK_TIMEOUT', 'errors.network.timeout', true, err instanceof Error ? err.message : String(err));
    }
    return new NetworkError('NETWORK_OFFLINE', 'errors.network.offline', true, err instanceof Error ? err.message : String(err));
}
//# sourceMappingURL=errors.js.map